// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.imp-banner {
  position: sticky;
  top: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 1rem;
  background: linear-gradient(90deg, #ba3939 0%, #d65151 100%);
  color: #fff;
  font-size: 0.875rem;
  box-shadow: 0 2px 8px rgba(186, 57, 57, 0.35);
}

.imp-icon {
  font-size: 1.25rem;
  width: 1.25rem;
  height: 1.25rem;
  line-height: 1.25rem;
}

.imp-text {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
  min-width: 0;
}

.imp-target {
  opacity: 0.92;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.imp-target small {
  opacity: 0.75;
  margin-inline-start: 0.25rem;
}

.imp-exit {
  background: rgba(255, 255, 255, 0.18) !important;
  color: #fff !important;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

.imp-exit:hover {
  background: rgba(255, 255, 255, 0.28) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/layout/components/impersonation-banner/impersonation-banner.component.ts"],"names":[],"mappings":"AACM;EACE,gBAAA;EACA,MAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,4DAAA;EACA,WAAA;EACA,mBAAA;EACA,6CAAA;AAAR;;AAEM;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;AACR;;AACM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,OAAA;EACA,YAAA;AAER;;AAAM;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAGR;;AADM;EACE,aAAA;EACA,4BAAA;AAIR;;AAFM;EACE,gDAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;AAKR;;AAHM;EACE,gDAAA;AAMR","sourcesContent":["\n      .imp-banner {\n        position: sticky;\n        top: 0;\n        z-index: 1100;\n        display: flex;\n        align-items: center;\n        gap: 0.75rem;\n        padding: 0.5rem 1rem;\n        background: linear-gradient(90deg, #ba3939 0%, #d65151 100%);\n        color: #fff;\n        font-size: 0.875rem;\n        box-shadow: 0 2px 8px rgba(186, 57, 57, 0.35);\n      }\n      .imp-icon {\n        font-size: 1.25rem;\n        width: 1.25rem;\n        height: 1.25rem;\n        line-height: 1.25rem;\n      }\n      .imp-text {\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n        flex: 1;\n        min-width: 0;\n      }\n      .imp-target {\n        opacity: 0.92;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n      .imp-target small {\n        opacity: 0.75;\n        margin-inline-start: 0.25rem;\n      }\n      .imp-exit {\n        background: rgba(255, 255, 255, 0.18) !important;\n        color: #fff !important;\n        font-weight: 700;\n        display: inline-flex;\n        align-items: center;\n        gap: 0.25rem;\n      }\n      .imp-exit:hover {\n        background: rgba(255, 255, 255, 0.28) !important;\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
